module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/product.svg?1b84771d425cb996c88fa0ff703f27a3";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/product.svg
// module id = 14
// module chunks = 0